import React from 'react';
import Container from '../components/Container.jsx';
import SectionDivider from '../components/SectionDivider.jsx';
import Card from '../components/Card.jsx';
import FeatureHighlight from '../components/FeatureHighlight.jsx';
import QuoteBlock from '../components/QuoteBlock.jsx';

const investments = [
  { title: 'Droit d’entrée', value: '20 000 €', desc: 'Accès à la marque et au savoir-faire Antic.' },
  { title: 'Investissement initial', value: '120 000 €', desc: 'Aménagement, matériel, formation.' },
  { title: 'Redevance', value: '5% CA', desc: 'Contribution au développement du réseau.' },
  { title: 'Zone exclusive', value: 'Oui', desc: 'Protection territoriale pour chaque franchisé.' },
];

const formats = [
  { icon: '🏪', title: 'Boutique urbaine', description: 'Format compact, idéal centre-ville.' },
  { icon: '🏬', title: 'Corner centre commercial', description: 'Emplacement premium en galerie marchande.' },
  { icon: '🚚', title: 'Food truck', description: 'Mobilité et proximité pour tous les événements.' },
];

export function FranchisePage() {
  return (
    <>
      <Container className="py-12 max-w-4xl">
        <h1 className="text-3xl font-heading font-bold text-primary mb-6 text-center">Devenir franchisé Antic</h1>
        <QuoteBlock
          quote="Rejoindre Antic, c’est partager une passion et un savoir-faire d’exception."
          author="Yann Leclerc, Fondateur"
        />
        <p className="text-lg text-text-secondary text-center mb-8">
          Antic accompagne ses franchisés à chaque étape : formation, ouverture, communication et suivi personnalisé.
        </p>
      </Container>
      <SectionDivider motif />
      <Container className="py-12">
        <h2 className="text-2xl font-heading font-bold text-primary mb-8 text-center">Investissement & conditions</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          {investments.map((inv) => (
            <Card key={inv.title} className="text-center p-6">
              <div className="font-heading text-lg font-bold text-primary mb-2">{inv.title}</div>
              <div className="text-2xl font-extrabold text-accent mb-1">{inv.value}</div>
              <div className="text-text-secondary text-sm">{inv.desc}</div>
            </Card>
          ))}
        </div>
        <h3 className="text-xl font-heading font-bold text-primary mb-6 text-center">Formats disponibles</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {formats.map((f) => (
            <FeatureHighlight key={f.title} {...f} />
          ))}
        </div>
        <div className="text-center mt-12">
          <a href="#contact"><button className="btn-primary px-8 py-4 rounded-lg text-lg">Demander une documentation</button></a>
        </div>
      </Container>
    </>
  );
}

export default FranchisePage;
